import { useMemo } from 'preact/hooks';
import { useCachedFetch } from '@core/utils/hooks/use-cached-fetch';

export function useApiKeysData(remoteSystemId) {
    const fetchUrl = remoteSystemId ? `/keys?remoteSystemId=${remoteSystemId}` : null;

    // your convention is [url, {}]; keep it
    const emptyParams = useMemo(() => ({}), []);
    const fetchCacheKey = useMemo(
        () => (fetchUrl ? [fetchUrl, emptyParams] : null),
        [fetchUrl, emptyParams]
    );

    const query = useCachedFetch(fetchUrl, emptyParams, { enabled: !!remoteSystemId });

    return { ...query, fetchUrl, fetchCacheKey };
}
